// removed by extract-text-webpack-plugin
module.exports = {"statistics":"_2poskKOvK0PiaE6kYyUimF","statisticsButton":"_3T9C7CVu_YrCHjEhuAh2Qx","sButtonItem":"H-T5Xs-NoU_KsD_lU47Xu","line":"_1ho39bGnAcAQ3PxMqeQUk4"};


//////////////////
// WEBPACK FOOTER
// ./src/components/BaseMultConsumption/index.less
// module id = 191
// module chunks = 0